import React from 'react'
import PropTypes from 'prop-types'
import { BoxedLink } from 'components/qstrap'

const propTypes = {
  studyFields: PropTypes.array,
}

function StudyFieldList({ studyFields }) {
  return (
    <div>
      {
        studyFields.map(studyField => (
          <div key={studyField.id} className="col-md-4 col-lg-3">
            <a href={`/directory?study_field=${studyField.name}`}>
              <BoxedLink color="white" svgIcon="next" name={studyField.name} />
            </a>
          </div>
        ))
      }
    </div>
  )
}

StudyFieldList.propTypes = propTypes

export default StudyFieldList
